import LabeledInput from "./component-library16.mjs";
import InputWrapper from "./component-library17.mjs";
import "./component-library117.mjs";
import normalizeComponent from "./component-library82.mjs";
const _sfc_main = {
  components: { InputWrapper },
  mixins: [LabeledInput],
  props: {
    name: {
      type: String,
      required: true
    },
    val: {
      type: String,
      default: "on"
    },
    value: { type: String, default: null },
    checked: { type: Boolean }
  },
  emits: ["input"],
  methods: {
    onChange() {
      this.$emit("input", this.val);
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("InputWrapper", _vm._b({ staticClass: "radio-input", attrs: { "show-label": "" }, scopedSlots: _vm._u([{ key: "label", fn: function({ id: wrapperId }) {
    return [_c("input", { staticClass: "radio-input__input", attrs: { "id": wrapperId, "type": "radio", "name": _vm.name, "aria-invalid": !!_vm.errorMessage, "aria-describedby": `${wrapperId}-error`, "required": _vm.required, "disabled": _vm.disabled }, domProps: { "value": _vm.val, "checked": _vm.val === _vm.value }, on: { "change": _vm.onChange } }), _c("span", { staticClass: "radio-input__icon" }), _c("div", [_vm._t("default", function() {
      return [_vm._v(" " + _vm._s(_vm.label) + " ")];
    }), _vm.required ? _c("span", { staticClass: "input-wrapper__required" }, [_vm._v("*")]) : _vm._e()], 2)];
  } }], null, true) }, "InputWrapper", _vm.inputWrapperProps, false));
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "0e9a3e14",
  null,
  null
);
const RadioInput = __component__.exports;
export {
  RadioInput as default
};
